export enum Role {
  anonymous = 'anonymous',
  teacher = 'teacher',
  municipalityAdministrator = 'municipality-administrator',
  administrator = 'administrator',
}
